import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import '../InfluencerSignUp.css';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  select: {
    marginBottom: '50px',
    width: '250px',
    marginTop: '0px',
    background: 'white',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  ageInput: {
    marginBottom: '50px',
    width: '100px'
  },
  displayNameInput: {
    marginBottom: '50px',
    width: '200px'
  },
  buttons: {
    marginTop: '50px',
    display: 'flex',
    justifyContent: 'center'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  }
});

class InfluencerInfo extends React.Component {
  constructor() {
    super();

    this.initialState = {
      submitAttempted: false,
      displayNameError: '',
      emailError: '',
      countryError: '',
      ageError: '',
      genderError: ''
    };

    this.state = {
      ...this.initialState
    };
  }

  handleNext() {
    this.setState({
      submitAttempted: true
    });

    if (!this.props.displayName) {
      this.setState({
        displayNameError: 'display name is required'
      });
    } else {
      this.setState({
        displayNameError: ''
      });
    }

    if (!this.props.customEmail) {
      this.setState({
        emailError: 'email is required'
      });
    } else {
      this.setState({
        emailError: ''
      });
    }

    if (!this.props.country) {
      this.setState({
        countryError: 'country is required'
      });
    } else {
      this.setState({
        countryError: ''
      });
    }

    if (!this.props.age) {
      this.setState({
        ageError: 'age is required'
      });
    } else {
      this.setState({
        ageError: ''
      });
    }

    if (!this.props.gender) {
      this.setState({
        genderError: 'gender is required'
      });
    } else {
      this.setState({
        genderError: ''
      });
    }

    if (
      this.props.country &&
      this.props.age &&
      this.props.gender &&
      this.props.customEmail
    ) {
      this.props.handleNextClick();
    }
  }

  render() {
    const {
      classes,
      changeHandler,
      customEmailChangeHandler,
      customEmail,
      country,
      gender,
      age,
      countries,
      displayName
    } = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          spacing={40}
          alignItems="center"
          justify="center"
          direction="column"
        >
          <Grid item xs={12} sm={12} className="info-input-container">
            <div>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
                error={
                  this.state.submitAttempted && this.state.displayNameError
                    ? true
                    : false
                }
                helperText={
                  this.state.submitAttempted ? this.state.displayNameError : ''
                }
              >
                Display Name
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'The display name companies will see - most people choose their Youtube or Twitch username.'
                }
              />
            </div>
            <TextField
              id="displayName"
              name="displayName"
              variant="outlined"
              className={classes.displayNameInput}
              defaultValue={displayName}
              onChange={changeHandler}
            />
            <div>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
                error={
                  this.state.submitAttempted && this.state.emailError
                    ? true
                    : false
                }
                helperText={
                  this.state.submitAttempted ? this.state.emailError : ''
                }
              >
                Email
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={
                  'This is the email all notifications on the platform will go to. Make sure you enter the correct email!'
                }
              />
            </div>
            <TextField
              id="email"
              name="email"
              variant="outlined"
              type="email"
              className={classes.displayNameInput}
              value={customEmail}
              onChange={customEmailChangeHandler}
              error={
                this.state.submitAttempted && this.state.emailError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.emailError : ''
              }
            />
            <div>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
              >
                Country
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={'Select which country you reside in.'}
              />
            </div>
            <TextField
              id="country"
              name="country"
              select
              className={classes.select}
              SelectProps={{
                MenuProps: {
                  className: classes.selectMenu
                }
              }}
              onChange={changeHandler}
              // margin="normal"
              variant="outlined"
              value={country}
              error={
                this.state.submitAttempted && this.state.countryError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.countryError : ''
              }
            >
              {[{ key: '', value: '' }, ...countries].map((item, i) => (
                <MenuItem key={item.key} value={item.value}>
                  {item.value}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={12} className="info-input-container">
            <div>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
              >
                Age
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={'Enter your age.'}
              />
            </div>
            <TextField
              id="age"
              name="age"
              display="inline"
              variant="outlined"
              className={classes.ageInput}
              type="number"
              onChange={changeHandler}
              value={age}
              error={
                this.state.submitAttempted && this.state.ageError ? true : false
              }
              helperText={this.state.submitAttempted ? this.state.ageError : ''}
            />
          </Grid>
          <Grid item xs={12} sm={12} className="info-input-container">
            <div>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                className="info-helper-text"
                color="textSecondary"
              >
                Gender
              </Typography>
              <HpTooltip
                styling={{
                  marginLeft: '5px',
                  marginBottom: '3px'
                }}
                message={'Enter your gender.'}
              />
            </div>
            <TextField
              id="gender"
              name="gender"
              select
              className={classes.select}
              SelectProps={{
                MenuProps: {
                  className: classes.selectMenu
                }
              }}
              onChange={changeHandler}
              margin="normal"
              variant="outlined"
              value={gender}
              error={
                this.state.submitAttempted && this.state.genderError
                  ? true
                  : false
              }
              helperText={
                this.state.submitAttempted ? this.state.genderError : ''
              }
            >
              {['Male', 'Female'].map((item, i) => (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button
            onClick={this.props.handleBackClick}
            className={classes.backButton}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleNext.bind(this)}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(InfluencerInfo);



// WEBPACK FOOTER //
// ./src/components/sign-up/influencer/components/InfluencerInfo.js